import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-pqrs',
  templateUrl: './header-pqrs.component.html',
  styleUrls: ['./header-pqrs.component.scss']
})
export class HeaderPqrsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
